import { createAsyncAction } from 'typesafe-actions';

import { ResourceLite } from '../resources/createResource';
import { EntityBase } from '../resources/types';

import sagaApi, { PayloadApiFailure, PayloadApiRequest, PayloadApiSuccess } from './sagaApi';

export interface SavePayload<E extends EntityBase> extends PayloadApiRequest<E> {
  resource: ResourceLite<E>;
  // Pass `data.id` for `put` methods, otherwise it'll be a `post`
  // Use `request` actions to customize it more
  method?: never;
  // TODO: make `data` more strict
  data: any;
}

const save = createAsyncAction('@lib/save/REQUEST', '@lib/save/SUCCESS', '@lib/save/FAILURE', '@lib/save/CANCEL')<
  SavePayload<any>,
  PayloadApiSuccess<any>,
  PayloadApiFailure,
  any
>();

// saga
export function* sagaSave(action: ReturnType<typeof save.request>) {
  const {
    payload: { resource, data, meta, ...config },
  } = action;
  const { id } = data;

  // @ts-ignore
  return yield sagaApi({
    action: save,
    resource,
    method: id ? 'put' : 'post',
    url: id ? `${resource.url}/${id}` : resource.url,
    data: resource.saveRequestInterceptor(data),
    meta: {
      schema: resource.schema,
      messageSuccess: resource.saveMessageSuccess,
      messageError: resource.saveMessageError,
      ...meta,
    },
    ...config,
  });
}

export default save;
